import { format, formatDistance, parseISO } from 'date-fns'

export const timeFromNow = (date?: string | number | Date) => {
  if (!date) {
    return ''
  }

  const validDate = typeof date === 'string' ? new Date(date) : date

  return formatDistance(validDate, Date.now(), { addSuffix: true })
}

export const msToMin = (milliseconds: number) => {
  const minutes = milliseconds / 1000 / 60
  return minutes.toFixed(0)
}

export const durationToShortFormat = (milliseconds: number) => {
  const date = new Date(milliseconds)
  const hours = date.getUTCHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  if (hours && !minutes && !seconds) {
    return `${hours}h`
  }

  if (hours && minutes && !seconds) {
    return `${hours}h ${minutes}m`
  }

  if (hours && minutes && seconds) {
    return `${hours}h ${minutes}m ${seconds}s`
  }

  if (minutes && !seconds) {
    return `${minutes}m`
  }

  if (minutes && seconds) {
    return `${minutes}m ${seconds}s`
  }

  if (seconds) {
    return `${seconds}s`
  }

  if (milliseconds) {
    return `${milliseconds}ms`
  }

  return 0
}

export const formatMdxDate = (date?: string): string =>
  date ? format(parseISO(date), 'd MMM, yyyy') : ''
